import React from 'react';

function AddLeftIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='16'
			height='16'
			fill='none'
			viewBox='0 0 16 16'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M1.667 4.333c.132-.729.366-1.266.78-1.69C3.4 1.667 4.933 1.667 8 1.667c3.067 0 4.6 0 5.553.976.414.424.648.961.78 1.69M14.333 11.667c-.132.729-.366 1.266-.78 1.69-.953.976-2.486.976-5.553.976-3.067 0-4.6 0-5.553-.976-.414-.424-.648-.961-.78-1.69M1.67 6.667c-.003.39-.003.858-.003 1.316 0 .457 0 .967.003 1.358m12.66-2.674c.003.39.003.858.003 1.316 0 .457 0 .967-.003 1.358M1.667 8h1m10.666 0h1M8 6L6 8m0 0h4M6 8l2 1.667'
			></path>
		</svg>
	);
}

export default AddLeftIcon;
